import { render, staticRenderFns } from "./FormMessage.vue?vue&type=template&id=a0f7968e&scoped=true"
import script from "./FormMessage.vue?vue&type=script&lang=js"
export * from "./FormMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f7968e",
  null
  
)

export default component.exports